import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { paths } from '../../utils/routes'
import { CartContext } from '../../context/CartContext'
import toast from 'react-hot-toast';
import axios from 'axios';
import { useQueryClient } from 'react-query';

export default function Product({ product, wishlist, refetch, wishlistRefetch }) {
    const queryClient = useQueryClient();
    const { addToCart } = useContext(CartContext);
    const addProductToCart = async (produtId) => {
        try {
            const response = await addToCart(produtId);
            toast.success(response.data.message);
        } catch (error) {
            toast.error(error)
        }
    }

    const addProductToWishlist = async (productId) => {
        const headers = {
            token: localStorage.getItem("userToken"),
        };
        try {
            const response = await axios.post("https://ecommerce.routemisr.com/api/v1/wishlist", { productId }, { headers });
            // wishlistRefetch()
            queryClient.invalidateQueries('wishlist')
            toast.success('Product Added Successfully')
            return response.data;
        } catch (error) {
            throw error.response.data.message;
        }
    }
    const removeProductToWishlist = async (productId) => {
        const headers = {
            token: localStorage.getItem("userToken"),
        };
        try {
            const response = await axios.delete(`https://ecommerce.routemisr.com/api/v1/wishlist/${productId}`, { headers });
            // wishlistRefetch()
            queryClient.invalidateQueries('wishlist')

            toast.success('Product Removed Successfully')
            return response.data;
        } catch (error) {
            throw error.response.data.message;
        }
    }


    return <>
        <div className="col-md-2">
            <div className="product cursor-pointer py-3 px-2">
                <Link to={`${paths.productDetails}/${product.id}`}>
                    <img src={product.imageCover} alt={product.title} className='w-100' />
                    <span className='text-main font-sm fw-bolder'>{product.category.name}</span>
                    <h3 className='h6'>{product.title.split(' ').slice(0, 2).join(' ')}</h3>
                    <div className="d-flex justify-content-between mt-3">
                        <span>{product.price} EGP</span>
                        <span><i className='fas fa-star rating-color'></i>{product.ratingsAverage}</span>
                    </div>
                </Link>
                <div className="d-flex justify-content-center align-items-center">
                    <button className='btn bg-main text-white w-75 btn-sm mt-2 me-2' onClick={() => addProductToCart(product.id)}>Add to cart</button>
                    <button className='btn bg-main text-white btn-sm mt-2' onClick={wishlist.includes(product.id) ? () => removeProductToWishlist(product.id) : () => addProductToWishlist(product.id)}> <i className={`${wishlist.includes(product.id) ? 'text-danger' : 'text-white'} fas fa-heart`}></i></button>
                </div>


            </div>
        </div>
    </>
} 
